export default __webpack_public_path__ + "static/media/pic-prof.2e3705c6.png";